/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
} from '@mui/material';

import { ButtonPrimary } from '../../../../shared/components';
import useGlobalStore from '../../../../shared/store/globalStore';

export default function CreateReturnReasonDialog({
  isDialogOpen,
  setIsDialogOpen,
}) {
  const [newReasonValue, setNewReasonValue] = useState('');
  const addReturnReason = useGlobalStore(
    (state) => state.configurationRules.addReturnReason,
  );

  return (
    <Dialog
      open={isDialogOpen}
      onClose={() => setIsDialogOpen(false)}
      fullWidth
    >
      <DialogTitle>Adicionar novo motivo</DialogTitle>
      <Divider />
      <DialogContent>
        <TextField
          id="motivo"
          label="Motivo"
          variant="outlined"
          value={newReasonValue}
          onChange={(event) => setNewReasonValue(event.target.value)}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <ButtonPrimary.Normal
          label="CANCELAR"
          type="outline"
          onClick={() => {
            setNewReasonValue('');
            setIsDialogOpen(false);
          }}
        />
        <ButtonPrimary.Normal
          label="ADICIONAR"
          onClick={() => addReturnReason(newReasonValue)}
        />
      </DialogActions>
    </Dialog>
  );
}
